<template>
  <div>
    <hr />
    <h6>{{ $t("SEND_NEWS.Clipboard_ID") }}</h6>
    <b-button variant="flat-primary" class="btn-icon rounded-circle" @click="onCopy">
      <feather-icon icon="ClipboardIcon" />
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
export default {
  components: {
    BButton,
  },
  props: {
      newsData: {
      type: Object,
      require: true,
    },
  },
  methods: {
    onCopy() {
      this.$copyText(this.newsData._id).then(() => {
        messagesNotifyHelper.successNotify("Cópia", "ID copiada com sucesso");
      });
    },
  },
};
</script>

<style>
</style>